import {make} from 'vuex-pathify'
import json from '../../../static/competences.json'

const state = {
    languages: [],
    frameworks: [],
    databases: [],
    libraries: [],
    apis: [],
    tools: [],
    locales: [],
    loaded: false
}

const mutations = {
    ...make.mutations(state)
}

const actions = {
    ...make.actions(state),
    loadCompetences ({commit}) {
        commit('SET_LANGUAGES', json.languages)
        commit('SET_FRAMEWORKS', json.frameworks)
        commit('SET_DATABASES', json.databases)
        commit('SET_LIBRARIES', json.libraries)
        commit('SET_APIS', json.apis)
        commit('SET_TOOLS', json.tools)
        commit('SET_LOCALES', json.locales)
        commit('SET_LOADED', true)
    }
}

const getters = {
    ...make.getters(state),
    getLanguages () {
        return state.languages
    },
    getFrameworks () {
        return state.frameworks
    },
    getDatabases () {
        return state.databases
    },
    getLibraries () {
        return state.libraries
    },
    getApis () {
        return state.apis
    },
    getTools () {
        return state.tools
    },
    getLocales () {
        return state.locales
    },
    isLoaded () {
        return state.loaded
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}



// WEBPACK FOOTER //
// ./src/store/modules/competencesModule.js